import { useAppSelector } from '..'

export const useIsEligibleForGiftCards = (): boolean => useAppSelector((state) => state.giftcardEligibility.eligible)
